import {
  ProductCenter
} from '~/views/ProductCenter'
import Layout from '~/layout/index.vue'

const ProductCenterRoutes = {
  path: '/product',
  component: Layout,
  children: [
    {
      path: '',
      name: 'productCenter',
      component: ProductCenter,
      meta:{
        title: '产品中心',
        isBack: true,
        isHeaderShow: true
      }
    }
  ]
}

export {
  ProductCenterRoutes
}
